module.exports = __webpack_public_path__ + "img/cdz.83ee22f5.png";